// frontend/src/pages/ProjectProduction.tsx
import type { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import { useProjectFormStore } from "@/store/project-form-provider";
import { ProjectInputField } from "@/components/project-input-field";
import { ProjectSaveButton } from "@/components/project-save-button";
import { ProjectResetButton } from "@/components/project-reset-button";
import { InlineFieldWithInfo } from "@/components/InlineFieldWithInfo";

export default function ProjectProduction() {
  const { loading, error, formData, updateField, saveAll, resetAll, savingAll, getFieldType, getFieldOptions,
  } = useProjectFormStore();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    updateField(name, value);
  };

  const { t } = useTranslation();

  if (loading) return <div className="p-4 text-xs">{t("common.loading")}</div>;
  if (error || !formData) return <div className="p-4 text-elani text-xs">{t("common.error_loading_data")}</div>;

  return (
    <form className="max-w-md space-y-8 text-xs">

      <div className="space-y-2">
        <ProjectInputField label={t("project.production.capacity") + " (" + t("project.production.capacity_unit") + ")"} name="capacity" value={formData.capacity} onChange={handleChange} />
        <ProjectInputField label={t("project.production.specific_yield") + " (" + t("project.production.specific_yield_unit") + ")"} name="specific_yield" value={formData.specific_yield} onChange={handleChange} />
        <ProjectInputField label={t("project.production.relative_costs") + " (" + t("project.production.relative_costs_unit") + ")"} name="relative_costs" value={formData.relative_costs} onChange={handleChange} />
      </div>

      <div className="space-y-2">
        <ProjectInputField label={t("project.production.lifetime") + " (" + t("project.production.lifetime_unit") + ")"} name="lifetime" value={formData.lifetime} onChange={handleChange} />
        <InlineFieldWithInfo help={t("project.production.dc_commissioning_help")}>
          <ProjectInputField label={t("project.production.dc_commissioning")} name="dc_commissioning" value={formData.dc_commissioning} type={getFieldType("dc_commissioning")} onChange={handleChange} />
        </InlineFieldWithInfo>
        <InlineFieldWithInfo help={t("project.production.ac_commissioning_help")}>
          <ProjectInputField label={t("project.production.ac_commissioning")} name="ac_commissioning" value={formData.ac_commissioning} type={getFieldType("ac_commissioning")} onChange={handleChange} />
        </InlineFieldWithInfo>
      </div>

      <div className="pt-3 flex gap-2">
        <ProjectSaveButton onSave={saveAll} saving={savingAll} />
        <ProjectResetButton onReset={resetAll} saving={savingAll} />
      </div>
    </form>
  );
}